
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const goalMain = useStore((state) => state.goalMain);
  const setGoalMain = useStore((state) => state.setGoalMain);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goalMain.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={goalMain}
          onChange={(value) => {
            setGoalMain(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'goal-main',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Lose weight'}>
            <span>🧘</span> {t('onboarding.goalMain.options.loseWeight')}
          </Option>
          <Option value={"Eat better without losing weight"}>
            <span>🥗</span> {t('onboarding.goalMain.options.eatBetter')}
          </Option>
          <Option value={'Gain weight'}>
            <span>⚖️</span> {t('onboarding.goalMain.options.gainWeight')}
          </Option>
           <Option value={'Build muscle'}>
            <span>💪</span> {t('onboarding.goalMain.options.buildMuscle')}
          </Option>
          <Option value={'Other'}>
            <span>✨</span> {t('onboarding.goalMain.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
